<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="SystemVal" @change="ReSetPage" clearable placeholder="操作系统">
                    <el-option v-for="i in SystemList" :key="i.id" :label="i.system_name" :value="i.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增账号</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="nickname" label="名称" min-width="100"></el-table-column>
            <el-table-column prop="username" label="账号" min-width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" min-width="140" />
            <el-table-column prop="email" label="邮箱" min-width="160" />
            <el-table-column prop="systems" label="可操作项目" min-width="200" align="center">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <el-tag v-for="item in scope.row.systems" :key="item.system_sub_id" type="success">
                            {{item.system_sub_name || item.system_name}}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="80">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status==1">开启</el-tag>
                    <el-tag type="info" v-else>关闭</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="120"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope" v-if="scope.row.id !=1 && scope.row.id!=$Tools.localData('UserId')">
                    <el-tooltip effect="dark" content="角色选择" placement="top-start">
                        <i class="NavIcon el-icon-s-operation" @click="ToggleRole(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">                        
                        <i class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">
                          <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增账号':'修改账号'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">操作系统：</div>
                <el-cascader class="Wid" size="medium" v-model="NewData.system_sub_id" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
                <!-- <el-select class="Wid" size="medium" v-model="NewData.system_ids" placeholder="可登录系统" multiple>
                    <el-option v-for="item in SystemList" :key="item.id" :label="item.system_name"
                        :value="item.id"></el-option>
                </el-select> -->
            </div>
            <div class="DigItem">
                <div class="DigItemTit">名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入名称" v-model="NewData.nickname"></el-input>
            </div>
            <div class="DigItem" v-if="Type =='Add'">
                <div class="DigItemTit">账号：</div>
                <el-input class="Wid" size="medium" placeholder="请输入账号" v-model="NewData.username"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入密码" v-model="NewData.password"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">手机号：</div>
                <el-input class="Wid" size="medium" placeholder="请输入手机号" v-model="NewData.phone"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">邮箱：</div>
                <el-input class="Wid" size="medium" placeholder="请输入邮箱" v-model="NewData.email"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="角色选择" :visible.sync="RoleData.RoleBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit MarBom">分配角色：</div>
                <el-checkbox-group size="medium" v-model="RoleData.RoleIds" @change="ChangeRole">
                    <el-checkbox class="MarBom" v-for="item in RoleList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(RoleData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucRole">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                SystemVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                SystemList:"",
                NewData:{
                    id:'',
                    NewBlon:false,
                    nickname:"",
                    password:"",
                    username:"",
                    status:0,
                    phone: "",
                    email: "",
                    system_sub_id: "",
                },
                RoleList:"",
                RoleData:{
                    id:"",
                    RoleIds:[],
                    RoleBlon:false,
                }
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("SystemMenu"));
            this.GetData();
            this.GetRole();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/adminuser/index',{
                    keyword:this.SearchVal,
                    system_id:this.SystemVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetRole(){
                this.$get('/admin/role/index').then(res=>{
                    if(res){
                        this.RoleList = res.data[0].children;
                    }
                })
            },
            ToggleRole(row){
                this.RoleData.id = row.id;
                this.RoleData.RoleBlon = true;
                this.RoleData.RoleIds = row.role_ids
            },
            ChangeRole(i){
                this.RoleData.RoleIds = i;
            },
            SucRole(){
                if(this.RoleData.RoleIds.length ==0){
                    this.$message.error("请选择角色");
                    return 
                }
                this.$post('/admin/adminuser/assignRoles/'+this.RoleData.id,{
                    role_ids:this.RoleData.RoleIds,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.RoleData)
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.nickname = row.nickname;
                    this.NewData.username = row.username;
                    this.NewData.status = row.status;
                    this.NewData.phone = row.phone;
                    this.NewData.email = row.email;
                    this.NewData.system_sub_id = row.system_sub_data;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                if(this.Type=='Add'){
                    this.SucNew();
                }else{
                    this.SucEdit();
                }
                this.$Tools.ResetData(this.NewData)
            },
            SucEdit(){
                this.$put('admin/adminuser/update/'+this.NewData.id,this.NewData).then(res=>{
                    if(res){
                        this.$message.success("修改成功");
                        this.GetData();
                    }
                })
            },
            SucNew(row) {
                this.$post('/admin/adminuser/save',this.NewData).then(res=>{
                    if(res){
                        this.$message.success("添加成功");
                        this.ReSetPage();
                    }
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('admin/adminuser/delete/'+id).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
